const MAX_IMAGE_BYTES = 700 * 1000 * 1000;
const MAX_IMAGES_PER_REQUEST = 10;
const ACCEPTED_EXTENSIONS = [".jpg", ".jpeg", ".tif", ".tiff"];
const ACCEPTED_MIME_TYPES = ["image/jpeg", "image/jpg", "image/tif", "image/tiff"];

function validateClientImage(file) {
  const name = String(file?.name || "").toLowerCase();
  const type = String(file?.type || "").toLowerCase();
  const size = Number(file?.size);
  const acceptedExtension = ACCEPTED_EXTENSIONS.some((extension) =>
    name.endsWith(extension)
  );

  if (!acceptedExtension || (type && !ACCEPTED_MIME_TYPES.includes(type))) {
    return {
      valid: false,
      message: "Upload a flattened JPG or TIFF image.",
    };
  }
  if (!Number.isFinite(size) || size < 1 || size > MAX_IMAGE_BYTES) {
    return {
      valid: false,
      message: "Each image must be no larger than 700 MB.",
    };
  }
  return { valid: true, message: "" };
}

function validateClientBatch(files) {
  const count = Array.isArray(files) ? files.length : 0;
  if (count < 1) {
    return { valid: false, message: "Select at least one image." };
  }
  if (count > MAX_IMAGES_PER_REQUEST) {
    return {
      valid: false,
      message: `Upload no more than ${MAX_IMAGES_PER_REQUEST} images at once.`,
    };
  }
  return { valid: true, message: "" };
}

export {
  ACCEPTED_EXTENSIONS,
  ACCEPTED_MIME_TYPES,
  MAX_IMAGE_BYTES,
  MAX_IMAGES_PER_REQUEST,
  validateClientBatch,
  validateClientImage,
};
